import { PropsWithChildren } from 'react';
import { ChakraFlex } from '@equip.health/ui';

export const PatientNoteAiSummaryGradientBannerContainer = ({
  children,
}: PropsWithChildren) => {
  return (
    <ChakraFlex
      alignItems="center"
      animation="slide 1.0s ease-in forwards"
      background="linear-gradient(74deg, rgba(211, 241, 207, 0.12) 22.23%, rgba(190, 239, 245, 0.36) 100%)"
      borderRadius="12px"
      height="45px"
      justifyContent="space-between"
      marginY="12px"
      padding="12px 10px 12px 16px"
      width="100%"
    >
      {children}
    </ChakraFlex>
  );
};
